/* eslint-disable react/jsx-handler-names */
import { find, get, isEmpty, reduce, size } from "lodash";
import { MDBAlert, MDBInput, MDBSpinner } from "mdbreact";
import React, { Component, Fragment } from "react";
import Loadable from "react-loadable";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import {
  resetAlertSubmitFail,
  submitPayment
} from "~/actions/umc/submitPayment";
import Alert from "~/components/common/atoms/Alert";
import Modal from "~/components/common/molecules/Modal";
import { withTitle } from "~/components/common/molecules/TitleHelmet";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { partnerInfo } from "~/configs/partnerDetails";
import history from "~/history";
import {
  getAllPaymentMethod,
  getAllPaymentMultiBooking,
  hideModalPaymentMethod,
  resetPaymentMethod,
  selectedPaymentMethod,
  togglePaymentMethod
} from "~/store/payment/paymentAction";
import {
  bookingShareToPay,
  getBookingTree,
  repaymentBooking,
  reserveBooking,
  reserveMultipleBookings
} from "~/store/totalData/actions";
import { routerByPartnerId } from "~/utils/func";
import styles from "./style.module.scss";
import { createForm, createFormField } from "rc-form";
import cx from "classnames";
import validator from "validator";
import * as fnc from "~/utils/func";
import { updateUserInfo } from "~/store/user/userAction";

const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

const PaymentMethodPageDesktop = Loadable({
  loader: () => import("~/components/desktop/pages/PaymentMethod"),
  loading: LoadableLoading
});

class DetectPaymentMethod extends Component {
  constructor(props) {
    super(props);
    this.scrollToDiv = React.createRef();
    this.state = {
      isShowAlert: false,
      isShowPaymentConfirm: false,
      isShowPaymentHelpsConfirm: false,
      loadingSubmitBooking: false,
      updateVisa: {
        status: false,
        initValue: {}
      },
      isCheckedVisa: false,
      visaEntered: {
        status: false,
        info: {
          fullName: "",
          userName: "",
          email: ""
        }
      },
      selectedPaymentMethodGroupId: 0
    };
  }

  methods = {
    calculate: () => {
      const { schedulesSelected, selectedMethod } = this.props;
      const total = reduce(
        schedulesSelected,
        (sum, item) => {
          const price = Number(item.service.price);
          return sum + price;
        },
        0
      );
      const medpro = selectedMethod.medproFee
        ? Number(selectedMethod.medproFee)
        : 0;
      const fee = selectedMethod.rate ? Number(selectedMethod.rate) : 0;
      const feeMore = selectedMethod.constRate
        ? Number(selectedMethod.constRate)
        : 0;
      const phi = parseInt((total + medpro) * fee + feeMore);
      const phiThanhToan = phi;
      const phiThanhToanGiaoDich = phiThanhToan || 0;
      const totalPhi = medpro + phiThanhToanGiaoDich;
      return {
        total,
        totalPhi
      };
    },
    toggleAlertFail: () => {
      this.props.OnResetErrorMessgeSubmitPayment();
      this.setState(state => ({
        loadingSubmitBooking: false
      }));
    },
    handleDoPaymentHelps: () => {
      const { schedulesSelected } = this.props;

      this.props.selectedPaymentMethod(
        {
          code: "SHARE_PAYMENT",
          gatewayId: "SHARE_PAYMENT",
          sequence: 1,
          subTotal: get(schedulesSelected[0].service, "price", 0),
          totalFee: 0,
          grandTotal: get(schedulesSelected[0].service, "price", 0),
          type: "SHARE_PAYMENT"
        },
        "SHARE_PAYMENT"
      );
      this.props.reserveBooking();
      this.setState(state => ({
        isShowPaymentHelpsConfirm: false
      }));
    },
    handleDoPayment: () => {
      const { isRepayment, schedulesSelected } = this.props;

      if (isRepayment) {
        this.props.repaymentBooking();
      } else {
        if (schedulesSelected.length > 1) {
          this.props.reserveMultipleBookings();
        } else {
          this.props.reserveBooking();
        }
      }
      this.setState(state => ({
        isShowPaymentConfirm: false
      }));
    },

    toggleShowPaymentConfirm: () => {
      this.setState(state => ({
        isShowPaymentConfirm: !state.isShowPaymentConfirm
      }));
    },
    toggleShowPaymentHelpsConfirm: () => {
      this.setState(state => ({
        isShowPaymentHelpsConfirm: !state.isShowPaymentHelpsConfirm
      }));
    },

    selectPaymentMethodGroup: group => {
      this.props.resetPaymentMethod();
      if (
        group.methodId !== this.state.selectedPaymentMethodGroupId &&
        group.paymentTypes.length === 1
      ) {
        this.methods.handleSelectedMethod(
          group.paymentTypes[0],
          group.methodId
        );
      }
      this.setState({
        selectedPaymentMethodGroupId:
          group.methodId !== this.state.selectedPaymentMethodGroupId
            ? group.methodId
            : 0
      });
    },

    handleSelectedMethod: (method, methodId) => {
      if (method.checkEmail && !this.state.visaEntered.status) {
        this.methods.toogleModalVisa();
        if (method?.userInfo) {
          this.props.form.setFieldsValue({
            ...method.userInfo,
            confirm: false
          });
        }
      } else {
        this.props.selectedPaymentMethod(method, methodId);
        // Scroll to Btn Thanh toán
        if (this.scrollToDiv.current) {
          const {
            top,
            bottom
          } = this.scrollToDiv.current.getBoundingClientRect();
          if (top < 0 || bottom > window.innerHeight) {
            this.scrollToDiv.current.scrollIntoView({
              behavior: "smooth",
              block: "end"
            });
          }
        }
      }
    },
    toggleAlert: () => {
      this.setState({
        isShowAlert: !this.state.isShowAlert
      });
    },
    handleGoBack: () => {
      const { partnerId } = this.props;
      const route = routerByPartnerId("/xac-nhan-thong-tin", partnerId);
      this.props.history.push(route);
    },
    handleUpdateInfoUser: () => {
      this.props.form.validateFields((error, value) => {
        const { fullName, userName, email } = value;
        if (!error) {
          this.props.updateUserInfo({
            fullname: fullName,
            username: userName,
            email,
            isSaveEmail: true
          });
          this.setState({
            visaEntered: {
              status: true,
              info: {
                fullname: fullName,
                username: userName,
                email
              }
            }
          });
          this.methods.toogleModalVisa();
        }
      });
    },

    toogleModalVisa: () => {
      const { updateVisa, visaEntered } = this.state;
      if (!visaEntered.status) {
        this.setState(preState => ({
          updateVisa: { ...preState, status: !updateVisa.status }
        }));
      }
    }
  };

  styles = {
    loading: {
      position: "fixed",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)"
    },

    loading_submit_booking: {
      position: "fixed",
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      zIndex: 1000,
      backgroundColor: "black",
      opacity: 0.5
    },

    body_modal: {
      fontSize: "1rem"
    },
    body_modal_image: {
      margin: "auto",
      display: "block",
      objectFit: "cover",
      marginBottom: "10px",
      maxHeight: "100px"
    }
  };

  renderBodyModalConfirmPayment = () => {
    const { selectedMethod } = this.props;
    const selectedMethodName =
      Object.keys(selectedMethod).length > 0
        ? selectedMethod.name
        : "Chọn phương thức thanh toán";

    const price = get(selectedMethod, "grandTotal", 0);
    const selectedMethodImage = get(selectedMethod, "paymentIcon.path", "");

    if (selectedMethod.bankAccount) {
      const accountHolder = get(
        selectedMethod,
        "bankAccount.accountHolder",
        ""
      );
      const accountNumber = get(
        selectedMethod,
        "bankAccount.accountNumber",
        ""
      );
      const bankBranch = get(selectedMethod, "bankAccount.bankBranch", "");
      return (
        <Fragment>
          <div style={this.styles.body_modal}>
            {selectedMethodImage && (
              <img
                style={this.styles.body_modal_image}
                src={selectedMethodImage}
                alt={selectedMethodName}
              />
            )}
            <MDBAlert color="primary">
              <p>Thông tin chuyển khoản:</p>
              Tài khoản: <strong>{accountHolder}</strong> <br />
              Số tài khoản: <strong>{accountNumber}</strong> <br />
              Chi nhánh: <strong>{bankBranch}</strong> <br />
              Số tiền: <strong>{Number(price).toLocaleString("vi-VN")}đ</strong>
            </MDBAlert>
          </div>
        </Fragment>
      );
    }

    return (
      <Fragment>
        <div style={this.styles.body_modal}>
          {selectedMethodImage && (
            <img
              style={this.styles.body_modal_image}
              src={selectedMethodImage}
              alt={selectedMethodName}
            />
          )}
          <p>
            Thanh toán số tiền{" "}
            <strong>{Number(price).toLocaleString("vi-VN")}đ</strong> bằng{" "}
            {selectedMethodName}
          </p>
          <MDBAlert color="primary">
            Bạn sẽ nhận được phiếu khám bệnh ngay khi{" "}
            <strong>thanh toán thành công</strong>. Trường hợp không nhận được
            phiếu khám bệnh, vui lòng liên hệ <strong>19002115</strong>.
          </MDBAlert>
        </div>
      </Fragment>
    );
  };

  renderBodyVisaUmc = () => {
    const {
      form: { getFieldProps, getFieldError }
    } = this.props;

    const errorMessage = ele => {
      const field = getFieldError(ele);

      const mess = field ? field.join(", ") : null;
      return <span className={styles.input_warning}>{mess}</span>;
    };
    return (
      <div>
        <p className={styles.description}>
          Theo quy định của Tổ chức thẻ Quốc tế, vui lòng điền đầy đủ thông tin
          người thanh toán
        </p>
        <div className={styles.form_column}>
          <form
            className={cx(styles.form_contact_info, styles.form_contact_custom)}
          >
            <div className={styles.form_group}>
              <label htmlFor="label_name">
                Họ & tên<sup>*</sup>
              </label>
              <input
                {...getFieldProps("fullName", {
                  rules: [
                    {
                      required: true,
                      message: "Vui lòng nhập Họ và tên"
                    }
                  ]
                })}
                type="text"
                className="form-control"
                placeholder="Vui lòng nhập họ và tên"
              />
              {errorMessage("fullName")}
            </div>

            <div className={styles.form_group}>
              <label htmlFor="label_mobile">
                Số điện thoại<sup>*</sup>
              </label>
              <input
                {...getFieldProps("userName", {
                  rules: [
                    {
                      validator: this.validatePhone
                    }
                  ]
                })}
                type="text"
                className="form-control"
                placeholder="Vui lòng nhập số điện thoại"
              />
              {errorMessage("userName")}
            </div>

            <div className={styles.form_group}>
              <label htmlFor="label_email">
                Email<sup>*</sup>
              </label>
              <input
                {...getFieldProps("email", {
                  rules: [{ validator: this.validatorEmail }]
                })}
                type="text"
                className="form-control"
                placeholder="Vui lòng nhập email"
              />
              {errorMessage("email")}
            </div>

            <div className={styles.form_group}>
              <MDBInput
                {...getFieldProps("confirm")}
                label="Tôi xác nhận thông tin trên là chính xác và hoàn toàn chịu
                    trách nhiệm về thông tin này."
                type="checkbox"
                id="confirm"
                className={styles.input}
                onChange={e => {
                  this.setState({ isCheckedVisa: e.target.checked });
                }}
              />
            </div>
          </form>
        </div>
      </div>
    );
  };

  componentDidMount() {
    const {
      resetPaymentMethod,
      OnRequestAllPaymentMethod,
      getAllPaymentMultiBooking,
      hideModalPaymentMethod,
      schedulesSelected,
      getBookingTree,
      partnerId
    } = this.props;

    if (schedulesSelected.length === 0) {
      getBookingTree("", partnerId);
      const route = routerByPartnerId("/chon-chuyen-khoa", partnerId);
      history.push(route);
    }

    resetPaymentMethod();

    if (size(schedulesSelected) > 1) {
      getAllPaymentMultiBooking();
    } else {
      OnRequestAllPaymentMethod();
    }

    hideModalPaymentMethod();
  }

  validatePhone = (rule, value, callback) => {
    if (value) {
      const patternMobile = /(84|0[3|5|7|8|9])+([0-9]{8})\b/g;
      if (patternMobile.test(value)) {
        callback();
      } else {
        const patternPhone = /(84|0[3|5|7|8|9])+([0-9]{8})\b/g;
        if (patternPhone.test(value)) {
          callback();
        } else callback("Vui lòng nhập đúng định dạng!");
      }
    } else {
      callback("Vui lòng nhập số điện thoại!");
    }
  };

  validatorEmail = (rule, value, callback) => {
    if (typeof value !== typeof undefined && !!value) {
      const trimValue = (value + "").trim();
      if (!isEmpty(trimValue)) {
        if (!validator.isEmail(trimValue)) {
          callback("Vui lòng nhập đúng định dạng email !");
        } else callback();
      } else callback();
    } else callback("Vui lòng nhập email !");
  };

  handleCancel = () => {
    this.setState({ isCheckedVisa: false });
    this.methods.toogleModalVisa();
  };

  componentWillUnmount() {
    this.props.OnResetErrorMessgeSubmitPayment();
  }

  render() {
    const {
      errorMsg,
      errorBooking,
      isRedirectToPaymentSupportPage,
      loading,
      schedulesSelected
    } = this.props;

    if (schedulesSelected.length === 0) {
      return (
        <div className="loading">
          <MDBSpinner big />
        </div>
      );
    }

    const {
      isShowAlert,
      isShowPaymentConfirm,
      isShowPaymentHelpsConfirm,
      loadingSubmitBooking,
      isCheckedVisa,
      updateVisa
    } = this.state;

    const errorMessage =
      errorBooking.error_code === 1011
        ? `Chuyên khoa ${errorBooking.booking_info.subject.name}
        đã hết số khung giờ này. Vui lòng chọn lại khung giờ khác!`
        : errorBooking.error_code;

    if (isRedirectToPaymentSupportPage)
      return <Redirect to="/ho-tro-thanh-toan" />;

    if (loading) {
      return (
        <div className={styles.loading_spinner}>
          <div className={styles.loading}>
            <MDBSpinner big crazy tag="div" />
          </div>
        </div>
      );
    }

    return (
      <Fragment>
        <PaymentMethodPageDesktop
          {...this.props}
          {...this.methods}
          selectedPaymentMethodGroupId={this.state.selectedPaymentMethodGroupId}
        />
        <div ref={this.scrollToDiv} />

        {loadingSubmitBooking && !errorMsg && (
          <div style={this.styles.loading_submit_booking}>
            <div style={this.styles.loading}>
              <MDBSpinner big crazy tag="div" />
            </div>
          </div>
        )}

        <Modal
          iconTitle={<i className="fal fa-bell" />}
          modal={isShowPaymentConfirm}
          title="Xác nhận thanh toán"
          children={this.renderBodyModalConfirmPayment()}
          centered
          footer
          footerConfirm
          className="centered"
          toggle={this.methods.toggleShowPaymentConfirm}
          cancelText="Quay lại"
          okText="Đồng ý"
          onCancel={() => this.methods.toggleShowPaymentConfirm()}
          onOk={this.methods.handleDoPayment}
        />

        <Modal
          iconTitle={<i className="fal fa-bell" />}
          modal={isShowPaymentHelpsConfirm}
          title="Xác nhận thanh toán"
          children={this.renderBodyModalConfirmPayment()}
          centered
          footer
          footerConfirm
          className="centered"
          toggle={this.methods.toggleShowPaymentHelpsConfirm}
          cancelText="Quay lại"
          okText="Đồng ý"
          onCancel={() => this.methods.toggleShowPaymentHelpsConfirm()}
          onOk={this.methods.handleDoPaymentHelps}
        />

        <Alert
          isModal={!!errorBooking}
          message={errorMessage || ""}
          toggleAlert={this.methods.toggleAlertFail}
        />
        <Alert
          isModal={isShowAlert}
          message="Vui lòng chọn phương thức thanh toán"
          toggleAlert={this.methods.toggleAlert}
        />
        <Modal
          iconTitle={<i className="fal fa-bell" />}
          modal={updateVisa.status}
          title="Thông báo"
          centered
          className="centered"
          toggle={this.handleCancel}
          okText="Xác nhận"
          cancelText="Trở lại"
          footer
          footerConfirm
          okDisabled={!isCheckedVisa}
          onCancel={this.handleCancel}
          children={this.renderBodyVisaUmc()}
          onOk={() => this.methods.handleUpdateInfoUser()}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    },
    user: { IsAuthenticated },
    payment: { selectedMethod, data, showModal, price, methodId },
    doctorAndTime: { sumaryInfo },
    umcSubmitPayment: {
      isRedirectToPaymentSupportPage,
      errorMsg,
      errorBooking
    },
    features: { selectedFeature, selectedFeatureBooking },
    totalData: {
      schedulesSelected,
      bookingTree,
      loadingReserveBooking,
      loading,
      isRepayment,
      partnerId,
      subject: { isHasSubject },
      service: { isHasService },
      room: { isHasRoom },
      doctor: { isHasDoctor },
      extraConfig,
      flow
    },
    hospital: { selectedHospital }
  } = state;
  return {
    flow,
    extraConfig,
    IsAuthenticated,
    device: type,
    selectedMethod,
    sumaryInfo,
    isRedirectToPaymentSupportPage,
    errorMsg,
    errorBooking,
    showModal,
    data,
    selectedFeature,
    selectedFeatureBooking,
    schedulesSelected,
    bookingTree,
    loadingReserveBooking,
    price,
    loading,
    isRepayment,
    selectedHospital,
    partnerId,
    isHasSubject,
    isHasService,
    isHasRoom,
    isHasDoctor,
    methodId
  };
};

const mapDispatchToProps = dispatch => ({
  bookingShareToPay: code => {
    dispatch(bookingShareToPay(code));
  },

  OnRequestAllPaymentMethod: () => {
    dispatch(getAllPaymentMethod());
  },
  OnTogglePaymentMethod: () => {
    dispatch(togglePaymentMethod());
  },
  OnSubmitPayment: () => {
    dispatch(submitPayment());
  },
  OnResetErrorMessgeSubmitPayment: () => {
    dispatch(resetAlertSubmitFail());
  },
  selectedPaymentMethod: (method, methodId) => {
    dispatch(selectedPaymentMethod(method, methodId));
  },
  hideModalPaymentMethod: () => {
    dispatch(hideModalPaymentMethod());
  },
  resetPaymentMethod: () => dispatch(resetPaymentMethod()),
  reserveBooking: () => dispatch(reserveBooking()),
  reserveMultipleBookings: () => dispatch(reserveMultipleBookings()),
  getAllPaymentMultiBooking: () => dispatch(getAllPaymentMultiBooking()),
  repaymentBooking: () => dispatch(repaymentBooking()),
  getBookingTree: (text, id) => dispatch(getBookingTree(text, id)),
  updateUserInfo: info => dispatch(updateUserInfo(info))
});

const PaymentMethodHelmet = withTitle({
  component: DetectPaymentMethod,
  title: `${hospitalName.value} | Chọn hình thức thanh toán`
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  createForm({
    mapPropsToFields: props => {
      const { UserInfoForm } = props;
      console.log("UserInfoForm :>> ", UserInfoForm);
      return {
        fullName: createFormField(UserInfoForm?.fullName),
        userName: createFormField(UserInfoForm?.userName),
        email: createFormField(UserInfoForm?.email),
        confirm: createFormField(UserInfoForm?.confirm)
      };
    }
  })(PaymentMethodHelmet)
);
